var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-nav-bar',_vm._g(_vm._b({staticClass:"navbar",class:_vm.classObj[_vm.type],style:({
      background: _vm.bgColor,
      color: _vm.whiteArrowArr.includes(_vm.type)
        ? '#fff !important'
        : '#000 !important',
        zIndex:2000
    }),attrs:{"title":_vm.title,"border":false,"fixed":true,"left-text":"","right-text":"","safe-area-inset-top":true},on:{"click-left":_vm.onClickLeft},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._t("title",[_c('span',{style:({
          color: _vm.whiteArrowArr.includes(_vm.type)
            ? '#fff !important'
            : '#000 !important',
        })},[_vm._v("\n          "+_vm._s(_vm.title)+"\n        ")])])]},proxy:true},{key:"right",fn:function(){return [_vm._t("right")]},proxy:true}],null,true)},'van-nav-bar',_vm.$attrs,false),_vm.$listeners)),_vm._v(" "),(_vm.hasPlaceholder)?_c('div',{staticClass:"placeholder"}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-654e2b8e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar.vue
// module id = null
// module chunks = 